










































































































import Vue from "vue";
import Component from "vue-class-component";

import Page from "@/components/layout/Page.vue";
import Card from "@/components/layout/Card.vue";
import Row from "@/components/layout/Row.vue";
import Column from "@/components/layout/Column.vue";
import Container from "@/components/layout/Container.vue";
import IconButton from "@/components/basic/IconButton.vue";
import RequestButton from "@/components/basic/RequestButton.vue";
import Select from "@/components/form/Select.vue";
import SimpleCheckbox from "@/components/form/SimpleCheckbox.vue";

import ValidatedCombobox from "@/components/form/vee-validate/ValidatedCombobox.vue";
import ValidatedTextfield from "@/components/form/vee-validate/ValidatedTextfield.vue";
import ValidatedTextarea from "@/components/form/vee-validate/ValidatedTextarea.vue";
import HoverableDatatable from "@/components/collection/HoverableDatatable.vue";

import { SendReportToLabViewModel } from "@/report/vms/SendReportToLabViewModel";
import { SendReportToLabPresenter } from "@/report/presenters/SendReportToLabPresenter";
import { SendReportToLabController } from "@/report/controllers/SendReportToLabController";

import { AxiosGraphQLConnection } from "@/gateways/graphql/connections/AxiosGraphQLConnection";
import { AxiosLogger } from "@/logging/AxiosLogger";
import { ConsoleLogger } from "@/logging/ConsoleLogger";
import { WorkOrderService } from "../services/WorkOrderService";

@Component<SendReportToLabView>({
  components: {
    Page,
    Card,
    Container,
    Column,
    Row,
    ValidatedCombobox,
    ValidatedTextfield,
    ValidatedTextarea,
    HoverableDatatable,
    IconButton,
    RequestButton,
    Select,
    SimpleCheckbox
  },
  watch: {
    "vm.finished"(newVal) {
      if (newVal) {
        this.$router.push({ name: "work-order-meta" });
      }
    }
  }
})
export default class SendReportToLabView extends Vue {
  protected vm = new SendReportToLabViewModel();
  protected controller?: SendReportToLabController;

  protected initController(): SendReportToLabController {
    const connection = new AxiosGraphQLConnection(
      new AxiosLogger(new ConsoleLogger())
    );
    return new SendReportToLabController(
      new SendReportToLabPresenter(this.vm),
      new WorkOrderService(connection)
    );
  }

  protected created() {
    this.controller = this.initController();
  }

  protected mounted() {
    this.controller?.mounted(this.$route.params.week);
  }

  protected openPdf(location: string) {
    window.open(location, "_blank");
  }

  protected downloadReportXlsx(id: string) {
    this.controller?.downloadReportXlsx(id);
  }
}
